import {inject, Injectable} from '@angular/core';
import {AttachProductCardImage, ProductCardImage} from "../types/product-card-image.types";
import {ProductCardImagesApiService} from "../services-api/product-card-images-api.service";

@Injectable({
  providedIn: 'root'
})
export class ProductCardImagesService {
  private productCardImagesApiService: ProductCardImagesApiService = inject(ProductCardImagesApiService);

  public getProductCardImages(productCardId: number): Promise<Array<ProductCardImage>> {
    return new Promise((resolve, reject) => {
      this.productCardImagesApiService.getProductCardImages(productCardId).subscribe({
        next: (images: Array<ProductCardImage>) => resolve(images),
        error: (error) => reject(error)
      });
    });
  }

  public attachProductCardImage(attachProductCardImage: AttachProductCardImage): Promise<ProductCardImage> {
    return new Promise((resolve, reject) => {
      this.productCardImagesApiService.attachProductCardImage(attachProductCardImage).subscribe({
        next: (productCardImage) => resolve(productCardImage),
        error: (error) => reject(error)
      });
    });
  }

  public deleteProductCardImage(id: number): Promise<void> {
    return new Promise((resolve, reject) => {
      this.productCardImagesApiService.deleteProductCardImage(id).subscribe({
        next: () => resolve(),
        error: (error) => reject(error)
      });
    });
  }
}
